export default __webpack_public_path__ + "media/play-button.abd136f3.svg";